export default "__VITE_ASSET__Cf3r0_Qw__"